import gql from 'graphql-tag';

export default gql`
  fragment payjpCardFragment on PayjpCardType {
    id
    cardId
    customerId
    created
    name
    last4
    expMonth
    expYear
  }
`;
